/**
 * Anularjs Module for pop up timepicker
 */
angular.module('timepickerPop', ['ui.bootstrap'])
  .factory('timepickerState', function () {
    var pickers = [];
    return {
      addPicker: function (picker) {
        pickers.push(picker);
      },
      closeAll: function () {
        for (var i = 0; i < pickers.length; i++) {
          pickers[i].close();
        }
      }
    };
  })
  .directive("timeFormat", function($filter) {
    return {
      restrict : 'A',
      require : 'ngModel',
      link : function(scope, element, attrs, ngModel , controller) {
        var parseTime = function (viewValue) {
          if (!viewValue) {
            ngModel.$setValidity('time', true);
            return null;
          } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
            ngModel.$setValidity('time', true);
            return viewValue;
          } else if (angular.isString(viewValue)) {
            var timeRegex = /^(0?[0-9]|1[0-2]):[0-5][0-9] ?[a|p]m$/i;
            if (!scope.showMeridian) {
              timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
            }
            if (!timeRegex.test(viewValue)) {
              ngModel.$setValidity('time', false);
              return undefined;
            } else {
              ngModel.$setValidity('time', true);
              var date = new Date();
              var sp = viewValue.split(":");
              var apm = sp[1].match(/[a|p]m/i);
              if (apm) {
                sp[1] = sp[1].replace(/[a|p]m/i, '');
                if (apm[0].toLowerCase() == 'pm') {
                  sp[0] = sp[0] + 12;
                }
              }
              date.setHours(sp[0], sp[1]);
              return date;
            };
          } else {
            ngModel.$setValidity('time', false);
            return undefined;
          };

        };
        ngModel.$parsers.push(parseTime);

        var showTime = function(data) {
          parseTime(data);
          var timeFormat = (!scope.showMeridian) ? "HH:mm" : "hh:mm a";
          return $filter('date')(data, timeFormat);
        };
        ngModel.$formatters.push(showTime);
        //controller.$formatters.shift();
        //ngModel.$parsers.push("10:2");
      }
    };
  })
  .directive('timepickerPop', function ($document, timepickerState) {
    return {
      restrict: 'E',
      transclude: false,
      controller: function ($scope, $element) {
        $scope.isOpen = false;


        $scope.toggle = function () {
          if ($scope.isOpen) {
            $scope.close();
          } else {
            $scope.open();
          }
        };
      },
      link: function (scope, element, attrs) {
        var picker = {
          open: function () {
            timepickerState.closeAll();
            scope.isOpen = true;
          },
          close: function () {
            scope.isOpen = false;
          }

        }
        timepickerState.addPicker(picker);

        scope.open = picker.open;
        scope.close = picker.close;
        element.bind('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
        });

        $document.bind('click', function (event) {
          scope.$apply(function () {
            scope.isOpen = false;
          });
        });
      }
    };
  });



// WEBPACK FOOTER //
// ./src/vendor/time-picker/timepickerpop.js